export default __webpack_public_path__ + "static/media/capteurPorteCap.903c375c.jpg";